module.exports = __webpack_public_path__ + "img/Z86Q_07.ba6b4b7d.jpg";